const HandleResize = {
  methods: {
    checkResizes() {
      this.$store.commit("UPDATE_WINDOW_SIZE");
    },
  },
  mounted() {
    this.checkResizes();
    window.addEventListener(
      "resize",
      () => {
        if(window.innerWidth === window.prevInnerWidth && window.innerWidth < 1024) return;
        this.checkResizes();
        window.prevInnerWidth = window.innerWidth;
      },
      false
    );
  },
};

export default HandleResize;
